import Select from 'corp/components/UI/Select';
import Tooltip from 'design-system/Tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ICommunityOption } from '@scale/shared/types/Community';

interface ISelectCommunityProps {
  fullWidth: boolean;
  multi: boolean;
  value: string[];
  communityOptions: ICommunityOption[];
  onChange: (communities: { label: string; value: string }[]) => void;
  style: { [key: string]: string } & { width: string };
  communities: string[];
}

const SelectCommunity = (props: ISelectCommunityProps) => {
  const hasNoCommunitiesSelected = !props?.value?.length;
  const { communityOptions = [] } = props;

  return (
    <>
      <div className="select-communities-container">
        <Select {...props} options={communityOptions} placeholder="Select Community" />
        {hasNoCommunitiesSelected ? (
          <Tooltip title="You must select at least one community" placement="top" arrow>
            <FontAwesomeIcon icon="warning" style={{ color: '#9CA3AF', fontSize: '20px' }} />
          </Tooltip>
        ) : (
          <Tooltip title="The communities where the channels will be created" placement="top" arrow>
            <FontAwesomeIcon icon="circle-info" style={{ color: '#9CA3AF', fontSize: '20px' }} />
          </Tooltip>
        )}
      </div>
      <style jsx>{`
        .select-communities-container {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          gap: 8px;
        }
      `}</style>
    </>
  );
};

export default SelectCommunity;
